export enum StepFunctionTypeOptions {
    Endpoint = 'endpoint',
    CustomCode = 'custom-code',
    WorkflowServices = 'workflow-service',
    WorkflowStepFunctions = 'workflow-step-function',
    WorkflowEvents = 'workflow-event'
}
